import React, { useState } from 'react';
import { Button, Input, useToasts } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { useResetAPIKey } from 'routes/screens/settings/hooks';
import Icon from 'shared/components/Icon';
import Spacer from 'shared/components/Spacer';
import { useGetAccountInfo } from 'shared/hooks';
import { Container } from './account-email-hash';

const AccountAPIKey = () => {
  const { t } = useTranslation();
  const [apiKey, setApiKey] = useState<string>('');
  const [showAPIForm, setShowAPIForm] = useState<boolean>(false);
  const [isCopyClicked, setIsCopyClicked] = useState<boolean>(false);
  const [, setToast] = useToasts();

  const { data: accountinfo, isLoading: isAccountLoading } = useGetAccountInfo({
    enabled: true,
  });

  const { mutate: generatedApiKey, isLoading: resetloading } = useResetAPIKey({
    setToast,
  });

  const toggleDisplay = () => {
    setShowAPIForm(true);
  };

  const onCopyClick = async (copiedData: string) => {
    const cb = navigator.clipboard;
    await cb.writeText(copiedData);
    setIsCopyClicked(true);
    setTimeout(() => {
      setIsCopyClicked(false);
    }, 1500);
  };

  React.useEffect(() => {
    if (accountinfo && accountinfo.api_key) {
      setApiKey(accountinfo.api_key);
    }
  }, [accountinfo]);

  return (
    <>
      {showAPIForm ? (
        <>
          {!isAccountLoading && apiKey && (
            <Container>
              <Input
                type="text"
                readOnly
                disabled
                value={apiKey}
                label={`${t('forms.labels.API_key')}`}
                endAdornment={
                  <Button
                    type="secondary"
                    className="copy"
                    disabled={isCopyClicked}
                    onClick={() => onCopyClick(apiKey)}
                  >
                    {isCopyClicked ? (
                      t('copied')
                    ) : (
                      <>
                        <Icon
                          glyph="copy"
                          width={12}
                          height={12}
                          viewBox="0 -1 14 16"
                        />
                      </>
                    )}
                  </Button>
                }
              />
              <Button
                inline
                type="secondary"
                className="reset-api-key"
                disabled={resetloading}
                onClick={() => generatedApiKey()}
              >
                {t('reset')}
              </Button>
            </Container>
          )}
        </>
      ) : (
        <div className="show-hide" onClick={() => toggleDisplay()}>
          <Icon glyph="view" width={16} height={16} /> <Spacer x={0.2} />{' '}
          {t('forms.labels.show_API_key')}
        </div>
      )}
    </>
  );
};

export default AccountAPIKey;
